export async function callTcapAdmin(accessToken) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;
    const scope = '20';
    headers.append('Authorization', bearer);
    headers.append('X-RequestScope', scope);

    const options = {
        method: 'GET',
        headers,
        mode: 'cors',
        credentials: 'omit',
    };

    try {
        const response = await fetch(
            `${import.meta.env.VITE_APP_API_URL}/AdminUser/me`,
            options,
        );

        if (!response.ok) {
            console.error('Failed to fetch admin user:', response.status);
            return null;
        }

        const adminData = await response.json();
        return adminData;
    } catch (error) {
        console.error('Error calling /AdminUser/me:', error);
        return null;
    }
}

export async function afterFirstLogin(data) {
    try {
        const authResponse = await callTcapAdmin(data.token);

        return authResponse;
    } catch (err) {
        console.error('Error in fetching tcap admin: ', err);
    }
}
